import { render, staticRenderFns } from "./DetailBlocksAccordion.vue?vue&type=template&id=6d136c82&scoped=true"
import script from "./DetailBlocksAccordion.vue?vue&type=script&lang=js"
export * from "./DetailBlocksAccordion.vue?vue&type=script&lang=js"
import style0 from "./DetailBlocksAccordion.vue?vue&type=style&index=0&id=6d136c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d136c82",
  null
  
)

export default component.exports